<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-sort
    v-model="selectedItemIds"
    data-url="admin/volume/"
    data-key="volumes"
    :extra-filters="{ 'sor.id': sorId }"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="volume-list"
  >
    <template #item.finalised_at="{ value }">
      {{ value ? $parseDate(value) : "" }}
    </template>
    <template #item.action_input_finalised_at="{ value }">
      {{ value ? $parseDate(value) : "" }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-col>
          <div style="display: flex; flex-direction: row">
            <v-btn
              v-if="canEditVolumeName"
              text
              color="primary"
              exact
              @click="editVolume(item)"
            >
              Edit
            </v-btn>
            <v-btn
              text
              color="primary"
              exact
              :to="{
                name: 'sor-volume',
                params: { sorId: sorId, volumeId: item.id },
              }"
            >
              More
            </v-btn>
            <v-btn
              text
              color="primary"
              v-if="
                $store.getters.hasPermission(PERMISSIONS.MANAGE_SOR) &&
                !item.action_input_finalised_at
              "
              @click="deleteItem(item)"
            >
              Delete
            </v-btn>
          </div>
        </v-col>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS } from "@/constants";
import EditVolumeNameDialog from "@/components/volume/EditVolumeNameDialog";
import { USER_TYPE } from "@/constants";

export default {
  name: "VolumeList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,

    editionId: String,
    sorId: String,
    sorFinalised: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    const canEditVolumeName = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].includes(
        root.$store.getters.account.type
      );
    });

    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      { text: root.$t("volume.order_no"), value: "order_no", width: 150 },
      { text: root.$t("volume.name"), value: "name", sortable: false },
      {
        text: root.$t("volume.finalised_at"),
        value: "finalised_at",
        width: 150,
      },
      {
        text: root.$t("volume.action_input_finalised_at"),
        value: "action_input_finalised_at",
        width: 150,
      },
      { text: "", value: "actions", sortable: false, width: 120 },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const editItem = async function (item) {
      root.$router.push({ name: "sor-detail", params: { sorId: item.id } });
    };
    const exportPdf = async function (item) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/section/export_pdf/",
        params: {
          section_id: item.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${item.name}.pdf`;
      link.click();
    };
    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Delete Volume?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/volume/delete/",
          params: { volume_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    const editVolume = async function (item) {
      const result = await root.$dialog.showAndWait(EditVolumeNameDialog, {
        volumeId: item.id,
        volumeName: item.name,
        showClose: false,
        persistent: true,
      });
      if (result) {
        await refresh();
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      exportPdf,
      deleteItem,

      PERMISSIONS,
      editVolume,
      canEditVolumeName,
    };
  },
};
</script>

<style lang="less">
.sor-list {
}
</style>
